import { CodeBlockLowlight } from "@tiptap/extension-code-block-lowlight";
// Import from main package - includes common languages pre-registered
// (bash, diff, go, json, makefile, markdown, python, rust, sql, typescript, yaml, and more)
import { lowlight } from "lowlight";

// Register aliases for convenience and alternate language names
// The base languages are already registered in the common bundle
lowlight.registerAlias("bash", ["shell", "sh"]);
lowlight.registerAlias("go", ["golang"]);
lowlight.registerAlias("makefile", ["make"]);
lowlight.registerAlias("markdown", ["md"]);
lowlight.registerAlias("python", ["py"]);
lowlight.registerAlias("rust", ["rs"]);
lowlight.registerAlias("typescript", ["ts", "tsx", "javascript", "js", "jsx"]);
lowlight.registerAlias("yaml", ["yml"]);

export const CustomCodeBlock = CodeBlockLowlight.configure({
  lowlight,
  HTMLAttributes: {
    class: "p-2 rounded text-sm overflow-x-auto border border-gray-200 dark:border-gray-700",
  },
});
